import { stripChipHtml } from "authoring/routes/macro/lib/macro-chip-utils"

export function sanitizeTitle(title) {
    if (typeof title !== "string") return title
    const withTokens = stripChipHtml(title)
    const doc = new DOMParser().parseFromString(withTokens, "text/html")
    return doc.body.textContent || ""
}

export function is0UTask(task) {
    if (!task) return false
    const {
        frequency: { interval, period },
    } = task

    return interval === 0 && period === "Unknown"
}

export function isOnlyHtmlTags(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html")
    const text = (doc.body.textContent || "").trim()
    return text.length === 0
}

export function validateTask(task) {
    if (!task) return false
    const emptyPlaceholders = new Set(["\n"])
    const { title, content, skillSet, frequency, classification } = task ?? {}
    const requiredFields = [title, content, skillSet, frequency, classification]

    return requiredFields.every((field) => {
        if (!field || emptyPlaceholders.has(field)) return false
        if (typeof field === "object" && Object.keys(field).length === 0) return false
        if (typeof field === "string" && isOnlyHtmlTags(field)) return false
        return true
    })
}

export function getParentSchedule({ projectSchedules, scheduleId }) {
    const scheduleData = projectSchedules?.find(({ id }) => scheduleId === id)
    return scheduleData ?? {}
}

export function getOriginalTask({ parentSchedule, originalTaskId }) {
    if (!parentSchedule || !originalTaskId) return null
    const task = parentSchedule?.tasks && parentSchedule?.tasks.find(({ taskId }) => originalTaskId === taskId)
    return task
}

export function sanitizeTask(task, additionalFields = []) {
    const taskCopy = structuredClone(task)
    if (typeof taskCopy.title === "string") {
        taskCopy.title = sanitizeTitle(taskCopy.title)
    }
    const fieldsToRemove = [
        "skill",
        "__typename",
        "frequency.__typename",
        "frequency.label",
        "frequency.code",
        ...additionalFields,
    ]
    fieldsToRemove.forEach((field) => deepUnset(taskCopy, field))
    return taskCopy
}

function deepUnset(obj, path) {
    const parts = path.split(".")
    let target = obj
    for (let i = 0; i < parts.length - 1; i++) {
        target = target?.[parts[i]]
        if (!target || typeof target !== "object") return
    }
    delete target[parts[parts.length - 1]]
}
